import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

import StreamTimer from './stream-timer'

function notSet () {
    return <span className="not-set">Not Set</span>;
}

const EventInfoTable = props => {
    var event = props.event
    var isLive = event.eventStatus === 'live';

    var content = isLive && event.liveStats ?
        (<tbody>
            <tr>
                <td colSpan="2" className="data-label">Start Date</td>
                <td colSpan="2" className="data-value">
                    {moment(event.liveStats.startDate).format('MMM. DD, HH:mm')}
                </td>
            </tr>
            <tr>
                <td colSpan="2" className="data-label">Stop Date</td>
                <td colSpan="2" className="data-value">
                    {event.liveStats.endDate ?
                        moment(event.liveStats.endDate).format('MMM. DD, HH:mm') :
                        notSet()
                    }
                </td>
            </tr>
            <tr>
                <td colSpan="2" className="data-label">Run Time</td>
                <td colSpan="2" className="data-value">
                    <StreamTimer timeZone={props.timeZone} event={event}/>
                </td>
            </tr>
        </tbody>) :

        (<tbody>
            <tr>
                <td className="data-value event-description">
                    <label>Description</label>

                    {event.description ?
                        <p
                            dangerouslySetInnerHTML={{__html: event.description}}
                        /> :
                        <p className="not-set">
                            No Description Set
                        </p>
                    }
                </td>
            </tr>
        </tbody>)
    ;

    return <Table condensed striped bordered>
        {content}
    </Table>;
}

export default EventInfoTable;
